export default __webpack_public_path__ + "static/media/DSC_0534.a2b24a94.webp";